import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

export const damageIdTitle: ResolveFn<string> = (route) => {
  const id = route.paramMap.get('id');
  return id ? `DA${id}` : '';
};

export const vehicleMovementsTitle: ResolveFn<string> = (route) =>
  route.queryParamMap.get('vin17')
    ? inject(TranslateService).instant('vin.vehicle.actions.route')
    : '';

export const commentsHistoryTitle: ResolveFn<string> = () =>
  inject(TranslateService).instant('vin.commentsHistory.heading');
